import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useLastRowDetection from '../../../hooks/useLastRowDetection';
import OptionInput from '../../OptionButton';
import { WrapperSection, Title, WrapperInputs, CollapsibleInputs, ToggleButton, Chevron } from './styles';

const PropertyType = ({
  device,
  register,
  setValue,
  watch,
  propertyTypesMostUsedOptions = [],
  propertyTypeOptions = [],
  getSubPropertyType,
  disabled = false
}) => {
  const { t } = useTranslation();
  const [active, setActive] = useState(false);
  const { containerRef, lastRowIndexes } = useLastRowDetection([active]);
  const selectedPropertyType = watch('propertyType');
  const PROPERTY_ID_OTHERS = '29';

  useEffect(() => {
    if (propertyTypeOptions?.length > 0) {
      propertyTypeOptions.forEach(property => selectedPropertyType === property?.realEstateTypeId && setActive(true));
    }
  }, [selectedPropertyType, propertyTypeOptions]);

  const handleChange = e => {
    e.preventDefault();
    const { value, name } = e.target;
    setValue(name, value);
    getSubPropertyType(value);
  };

  return (
    <>
      {propertyTypesMostUsedOptions && (
        <WrapperSection data-publi='mainData-propertyType'>
          <Title data-publi='mainData-propertyType-title'>{t('professionalPubli.main.propertyType')}</Title>
          <WrapperInputs device={device} numberColumns={4}>
            {propertyTypesMostUsedOptions.map((property, index) => (
              <OptionInput
                key={property.realEstateTypeId}
                type='radio'
                name='propertyType'
                value={property.realEstateTypeId}
                selected={selectedPropertyType === property.realEstateTypeId}
                onChange={handleChange}
                label={property.name}
                register={register}
                padding='0 4px'
                dataLabel={`${index + 1}`}
                disabled={disabled}
              />
            ))}
          </WrapperInputs>
          {propertyTypeOptions?.length > 0 && (
            <CollapsibleInputs ref={containerRef} device={device} active={active} data-publi='propertyType-others'>
              {propertyTypeOptions
                .sort((a, b) => {
                  if (a?.realEstateTypeId === PROPERTY_ID_OTHERS) return 1;
                  if (b?.realEstateTypeId === PROPERTY_ID_OTHERS) return -1;
                  return 0;
                })
                .map(
                  (property, index) =>
                    property !== null && (
                      <OptionInput
                        key={property?.realEstateTypeId}
                        type='radio'
                        name='propertyType'
                        value={property?.realEstateTypeId}
                        selected={selectedPropertyType === property?.realEstateTypeId}
                        onChange={handleChange}
                        label={property?.name}
                        register={register}
                        flexWidth={!lastRowIndexes.includes(index)}
                        padding='0 4px'
                        dataLabel={`${index + propertyTypesMostUsedOptions.length + 1}`}
                        disabled={disabled}
                      />
                    )
                )}
            </CollapsibleInputs>
          )}
          {propertyTypeOptions?.length > 0 && propertyTypeOptions?.every(property => property !== null) && (
            <ToggleButton
              data-publi='mainData-propertyType-showMore'
              device={device}
              onClick={e => {
                e.preventDefault();
                setActive(!active);
              }}
            >
              {t(`professionalPubli.main.toggle.${active ? 'showLess' : 'showMore'}`)}
              <Chevron active={active} data-publi='mainData-chevron' />
            </ToggleButton>
          )}
        </WrapperSection>
      )}
    </>
  );
};

PropertyType.propTypes = {
  device: PropTypes.string.isRequired,
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  propertyTypesMostUsedOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired
    })
  ),
  propertyTypeOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired
    })
  ),
  getSubPropertyType: PropTypes.func,
  disabled: PropTypes.bool
};

export { PropertyType };
